/* unplugin-vue-components disabled */
import {Rest, Tasks} from 'utils'
import {Cancelled} from 'utils/errors'
import {API2_TOOLS} from 'consts/api2'
import $profile from 'stores/profile'
import {
  POLL_INTERVAL, POLL_TIMEOUT,
  makeToolFields, fieldsToArgs, argsToForm, fieldError, errorText, elapsedSeconds
} from './test-tools-defs'

const TIMEOUT = Symbol('timeout')

export default {
  data() {
    return {
      rest: new Rest(),
      tasks: new Tasks(),
      tools: undefined,
      users: [],
      tool: '',
      user_id: '',
      form: {},
      raw: false,
      raw_text: '',
      raw_args: {},
      raw_error: undefined,
      running: false,
      task: undefined,
      timed_out: false,
      error: undefined
    }
  },
  computed: {
    tool_items() {
      return this.tools.map(tool => ({value: tool.name, title: tool.name}))
    },
    user_items() {
      return [
        {value: '', title: 'Run as me'},
        ...this.users.map(user => ({value: user.id, title: user.email ? `${user.name} (${user.email})` : user.name}))
      ]
    },
    current() {
      return this.tools?.find(tool => tool.name === this.tool)
    },
    fields() {
      return makeToolFields(this.current?.input_schema)
    },
    args() {
      return fieldsToArgs(this.fields, this.form)
    },
    errors() {
      const errors = {}
      for (const field of this.fields) {
        const err = fieldError(field, this.form[field.name])
        if (err) errors[field.name] = err
      }
      return errors
    },
    can_run() {
      if (!this.current || this.running) return false
      if (this.raw && this.raw_error) return false
      return !Object.keys(this.errors).length
    },
    has_output() {
      return this.task?.status === 'completed' && !!this.task.result && !this.task.result.no_content
    },
    is_array() {
      return this.has_output && Array.isArray(this.task.result.output)
    }
  },
  watch: {
    tool() {
      this.form = argsToForm(this.fields, {})
      this.raw_text = '{}'
      this.raw_args = {}
      this.raw_error = undefined
      this.task = undefined
      this.error = undefined
      this.timed_out = false
    },
    raw_text(text) {
      if (!this.raw) return
      try {
        const parsed = JSON.parse(text)
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) throw new Error()
        this.raw_error = undefined
        this.raw_args = parsed
        this.form = argsToForm(this.fields, parsed)
      }
      catch {
        this.raw_error = 'Input must be a valid JSON object'
      }
    }
  },
  async mounted() {
    const [tools, users] = await Promise.all([
      this.rest.get(API2_TOOLS),
      $profile.fetchUsers()
    ])
    this.users = users?.view_items || []
    this.tools = [...(tools || [])].sort((a, b) => a.name.localeCompare(b.name))
  },
  beforeUnmount() {
    this.tasks.cancelAll(false)
  },
  methods: {
    fieldError,
    elapsedSeconds,
    onRawToggle() {
      if (!this.raw) return
      this.raw_args = this.args
      this.raw_error = undefined
      this.raw_text = JSON.stringify(this.args, null, 2)
    },
    async run() {
      if (!this.can_run) return
      this.running = true
      this.task = undefined
      this.error = undefined
      this.timed_out = false

      try {
        const body = {tool: this.tool, args: this.raw ? this.raw_args : this.args}
        if (this.user_id) body.user_id = this.user_id

        const {id} = await this.rest.post(`${API2_TOOLS}/run`, body)
        this.task = {id, status: 'pending'}

        const timeout = $utils.timers.wait(POLL_TIMEOUT).then(() => TIMEOUT)
        const res = await Promise.race([
          this.tasks.waitTask(id, POLL_INTERVAL, data => { this.task = {id, ...data} }),
          timeout
        ])

        if (res === TIMEOUT) {
          this.tasks.cancelAll(false)
          this.timed_out = true
        }
        else {
          this.task = res
        }
      }
      catch (err) {
        if (!(err instanceof Cancelled)) {
          this.error = this.task && err.http_code === 404 ? 'Task not found' : errorText(err)
        }
      }
      this.running = false
    },
    async copyOutput() {
      await $utils.copyText($utils.format.json(this.task.result.output))
    }
  }
}
